import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as valueType from './value-type'

export const DOC = gql`
  ${valueType.DOC}
  fragment FragmentVariable on Variable {
    id
    name
    description
    defaultValue
    type {
      ...FragmentDmsValueType
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentVariableFragment,
  ents.core.dms.data.query.Variable
>({
  defaultValue: graphql.transformers.OUT.json(),
  description: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.data.query.Variable.Name.isName,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  type: graphql.transformers.OUT.validate(
    valueType.TRANSFORMER,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
})
